function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.75
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.55071 0.526767H4.23086L4.25048 9.5289C4.25048 11.0621 4.36724 11.0621 5.55071 11.0621C7.55 11.0621 9.08301 9.61829 8.98624 5.50027C8.8889 1.525 7.20047 0.526767 5.55071 0.526767ZM5.54065 12.1156H0V11.6504C0.540848 11.6504 0.839465 11.561 0.988502 11.4179C1.28748 11.1314 1.32411 10.9526 1.32411 6.06669C1.32411 1.18113 1.28748 0.984418 0.988502 0.697963C0.839465 0.554648 0.540848 0.483165 0 0.483165V0H5.54065C9.96244 0 12.1637 2.12954 12.1637 5.65519C12.1637 9.87862 9.64515 12.1156 5.54065 12.1156Z",
  fill: "currentColor"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.1014 9.55651L20.0105 12.1156H11.6396V11.6504C12.169 11.6504 12.4606 11.561 12.6066 11.4179C12.8981 11.1314 12.935 10.9526 12.935 6.06669C12.935 1.18113 12.8981 0.984418 12.6066 0.697963C12.4606 0.554648 12.169 0.483165 11.6396 0.483165V0H20.0105L20.1014 2.55897H19.5722L19.5543 2.30869C19.4813 1.37801 18.8796 0.787361 17.8034 0.787361H15.8341V5.44039H17.1656C18.5515 5.44039 18.9347 5.11828 19.044 4.00863H19.5722V7.64159H19.044C18.9347 6.53229 18.5515 6.21001 17.1656 6.21001H15.8341V9.75339C15.8341 11.2925 15.9436 11.3462 17.0559 11.3462H17.8217C18.77 11.3462 19.4634 10.7018 19.5364 9.80696L19.5543 9.55651H20.1014Z",
  fill: "currentColor"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0483 15.6465H9.55506L9.53642 15.3051C9.44516 14.6945 9.07993 13.8676 7.78257 13.8676H6.46763V21.7735C6.46763 24.5585 6.7597 24.7919 8.11157 24.7919V25.2409H1.93654V24.7919C3.28859 24.7919 3.58102 24.5585 3.58102 21.7735V13.8676H2.26519C0.968716 13.8676 0.603139 14.6945 0.511523 15.3051L0.49288 15.6465H0L0.0365754 13.0771H10.0117L10.0483 15.6465Z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3364 25.2404H10.0479V24.7733C10.559 24.7733 10.8412 24.6835 10.9822 24.5396C11.2641 24.2522 11.2996 24.0731 11.2996 19.1677C11.2996 14.2627 11.2641 14.0648 10.9822 13.7774C10.8412 13.6335 10.559 13.5616 10.0479 13.5616V13.0767H15.3364V13.5616C14.8249 13.5616 14.5428 13.6335 14.4018 13.7774C14.1193 14.0648 14.0843 14.2447 14.0843 19.1494C14.0843 24.0547 14.1193 24.2522 14.4018 24.5396C14.5428 24.6835 14.8249 24.7733 15.3364 24.7733V25.2404Z",
  fill: "currentColor"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.6861 13.5742C21.1402 13.5742 20.8385 13.648 20.688 13.7957C20.3866 14.0906 20.3489 14.2751 20.3489 19.3075V25.1702C20.3489 29.005 18.5221 30.0001 16.2441 30.0001H15.3398V29.5022C17.1097 29.5022 17.3172 28.1751 17.3364 25.4285C17.3364 25.4285 17.3546 24.7276 17.3546 21.8703V19.3263C17.3546 14.2936 17.3364 14.0906 17.0347 13.7957C16.8839 13.648 16.5828 13.5742 16.0369 13.5742V13.0767H21.6861V13.5742Z",
  fill: "currentColor"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.2318 13.6055H25.9125L25.9316 22.6436C25.9316 24.1827 26.0479 24.1827 27.2318 24.1827C29.2312 24.1827 30.7647 22.733 30.6679 18.5987C30.5709 14.6077 28.8824 13.6055 27.2318 13.6055ZM27.2224 25.2404H21.6816V24.7733C22.2232 24.7733 22.5213 24.6835 22.6706 24.5396C22.9694 24.2522 23.0068 24.0731 23.0068 19.1677C23.0068 14.2627 22.9694 14.0648 22.6706 13.7774C22.5213 13.6335 22.2232 13.5616 21.6816 13.5616V13.0767H27.2224C31.6438 13.0767 33.8454 15.2145 33.8454 18.7544C33.8454 22.9944 31.3269 25.2404 27.2224 25.2404Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/de-tijd.18a0ef63.svg";
export { SvgComponent as ReactComponent };